// extracted by mini-css-extract-plugin
export var searchHeader = "_9e-0";
export var searchHeaderDark = "_9e-1";